import React from 'react';

const Media = () => {
  // Sample media articles/press releases
  const mediaItems = [
    {
      id: 1,
      type: 'Press Release',
      title: 'Voters Deserve More Campaign Launches to Build Multiparty Democracy',
      date: 'March 15, 2025',
      summary: 'A new cross-caucus campaign called "Voters Deserve More" has launched with the aim of breaking America\'s two-party system and implementing proportional representation.',
      link: '#'
    },
    {
      id: 2,
      type: 'News Coverage',
      title: 'Electoral Reform Campaign Gains Momentum in Multiple States',
      date: 'February 28, 2025',
      summary: 'Progressive groups are building coalitions to support ballot initiatives for proportional representation in key states.',
      link: '#'
    },
    {
      id: 3,
      type: 'Opinion',
      title: 'Why America Needs a Multiparty Democracy Now',
      date: 'February 10, 2025',
      summary: 'Following the 2024 election, the case for electoral reform has never been stronger as voters express frustration with limited choices.',
      link: '#'
    }
  ];

  return (
    <div className="container page-container">
      <h1>Media Center</h1>
      <p>Find the latest news, press releases, and media resources related to the Voters Deserve More campaign.</p>
      
      <section style={{ marginTop: '30px' }}>
        <h2>Press Contact</h2>
        <p>For media inquiries, please contact our Press Secretary:</p>
        <p><strong>Email:</strong> press@votersdeservemore.org</p>
        <p><strong>Phone:</strong> (555) 123-4567</p>
      </section>
      
      <section style={{ marginTop: '40px' }}>
        <h2>Latest News & Press Releases</h2>
        <div style={{ marginTop: '20px' }}>
          {mediaItems.map(item => (
            <div key={item.id} style={{
              marginBottom: '25px',
              padding: '20px',
              backgroundColor: 'white',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '10px'
              }}>
                <span style={{
                  backgroundColor: item.type === 'Press Release' ? 'var(--primary)' : 
                                   item.type === 'News Coverage' ? 'var(--secondary)' : 'var(--dark)',
                  color: 'white',
                  padding: '4px 10px',
                  borderRadius: '4px',
                  fontSize: '0.8rem',
                  fontWeight: '600'
                }}>
                  {item.type}
                </span>
                <span style={{ color: '#666', fontSize: '0.9rem' }}>{item.date}</span>
              </div>
              <h3 style={{ fontSize: '1.3rem', marginBottom: '10px' }}>{item.title}</h3>
              <p>{item.summary}</p>
              <a href={item.link} style={{
                display: 'inline-block',
                marginTop: '10px',
                color: 'var(--primary)',
                fontWeight: '600',
                textDecoration: 'none'
              }}>
                Read More →
              </a>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Media;